var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 75,
    viewBox: "0 0 80 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 79.2253,
    height: 75,
    rx: 14,
    fill: "#5A47AB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 56H29.6868L32.3291 47.7667H47.6439L50.3132 56H57L44.7589 18H35.2411L23 56ZM32.3291 47.7667L39.9326 24.1486L45.7026 41.8292L32.3291 47.7667Z",
    fill: "#FBD15B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg3);
export default __webpack_public_path__ + "static/media/Img3.280159028ee65c62ed5c70107a7c3a8f.svg";
export { ForwardRef as ReactComponent };